import { NOTIFICATION_BROADCAST_TYPE } from "@/entities/notification-broadcast";
import { useEventBusListener } from "@/modules/event-bus";

import { useModelDeleteAsyncActionSuccess } from "./model-delete-async-action-success.hook";

export const ModelDeleteAsyncActionSuccess = () => {
  const { runAction } = useModelDeleteAsyncActionSuccess();
  useEventBusListener(
    NOTIFICATION_BROADCAST_TYPE.ASYNC_DELETE_SUCCESS,
    runAction
  );

  return <></>;
};
